import { FieldErrors } from 'react-hook-form';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useDocumentManagementStore } from '@/stores/documentManagement/documentManagement.store';
import { useInstitutionsStore } from '@/stores/institutions';
import { ERouterNames, TFormBuilderEditSchemaCamel } from '@/types';

export const useFormBuilderSubmit = () => {
  const { formBuilderId } = useParams();
  const navigate = useNavigate();
  const currentInstitutionId = useInstitutionsStore(
    (state) => state.currentInstitution?.id,
  );
  const {
    getFormBuilderTemplate,
    createFormBuilderTemplate,
    updateFormBuilderTemplate,
  } = useDocumentManagementStore((state) => ({
    createFormBuilderTemplate: state.createFormBuilderTemplate,
    getFormBuilderTemplate: state.getFormBuilderTemplate,
    updateFormBuilderTemplate: state.updateFormBuilderTemplate,
  }));

  const { state } = useLocation();

  const onSubmit = async (data: TFormBuilderEditSchemaCamel) => {
    if (!formBuilderId) return;
    try {
      if (formBuilderId !== 'empty') {
        const value = await getFormBuilderTemplate(formBuilderId.toString());
        if (!value) return;
        await updateFormBuilderTemplate({
          ...value,
          data,
        });
      } else {
        await createFormBuilderTemplate({
          institutionId: currentInstitutionId ?? '',
          isActive: true,
          data,
          userType: state?.userType,
        });
      }
      navigate(ERouterNames.DOCUMENT_MANAGEMENT);
    } catch (error) {
      console.error(error);
    }
  };

  const onError = (errors: FieldErrors<TFormBuilderEditSchemaCamel>) =>
    console.error('❌ ERRORS:', errors);

  return { onSubmit, onError };
};
